import { BundlePaymentPlan, MyBundleStatus } from 'multirpc-sdk';

import { getBundleChargingModel } from './getBundleChargingModel';

export interface GetPackageChargingModelParams {
  bundleStatus: MyBundleStatus;
  plans: BundlePaymentPlan[] | undefined;
}

// this value is hardcoded because package is no longer listed in bundles response.
// see details here: https://ankrnetwork.atlassian.net/browse/MRPC-4755
// and related discussion: https://ankr.slack.com/archives/C0482JES71T/p1713209633085639
const PACKAGE_REQUESTS_LIMIT = 30000000;

export const getPackageChargingModel = ({
  bundleStatus,
  plans,
}: GetPackageChargingModelParams) => {
  const plan = plans?.find(
    ({ bundle }) => bundle.bundle_id === bundleStatus.bundleId,
  );

  const creditsLimit =
    plan?.bundle.limits.find(({ blockchain_paths }) => blockchain_paths === '*')
      ?.limit || PACKAGE_REQUESTS_LIMIT;

  return getBundleChargingModel({
    bundleStatus,
    creditsLimit,
    type: 'package',
  });
};
